function validateCardNumericalFields(card) {
  if (typeof card.targetClientNumber !== 'undefined') {
    card.targetClientNumber = Number(card.targetClientNumber);
  }
  if (typeof card.resultingClientsNumber !== 'undefined') {
    card.resultingClientsNumber = Number(card.resultingClientsNumber);
  }
  if (typeof card.price !== 'undefined') {
    card.price = Number(card.price);
  }
  if (typeof card.totalCost !== 'undefined') {
    card.totalCost = Number(card.totalCost);
  }
}


function manageBmcCardRelationsAttributes(card) {
  if (!card.bmcCardRelations) {
    card.bmcCardRelations = [];
  }


  card.bmcCardRelations.forEach((relation) => {
    if (relation) {
      if (relation.kind === 'card') {
        if (!card.cardSelects || !card.cardSelects.find((c) => c.id === relation.cardId)) {
          relation._destroy = 1;
        }
      } else if (relation.kind === 'customer_segment') {
        if (!card.customerSegments || !card.customerSegments.find((c) => c.id === relation.cardId)) {
          relation._destroy = 1;
        }
      } else if (relation.kind === 'key_proposition') {
        if (!card.keyPropositions || !card.keyPropositions.find((c) => c.id === relation.cardId)) {
          relation._destroy = 1;
        }
      }
    }
  });


  addBmcCardRelationsAttributes(card);
}


function clearCircularStructure(card) {
  card.cardSelects = undefined;
  card.customerSegments = undefined;
  card.keyPropositions = undefined;
}


function updateBmcCardRelationsAttributes(card, bmcCardRelations) {
  card.bmcCardRelationsAttributes = bmcCardRelations;
}

function addBmcCardRelationsAttributes(card) {
  if (!card.bmcCardRelations) {
    card.bmcCardRelations = [];
  }

  let cardSelects = [];
  let customerSegments = [];
  let keyPropositions = [];


  if (card.cardSelects && card.cardSelects.length) {
    cardSelects = card.cardSelects.map((c) => {
      if (!card.bmcCardRelations.find((relation) => relation && relation.cardId === c.id)) {
        return { cardId: c.id, kind: 'card' };
      }
    });
  }

  if (card.customerSegments && card.customerSegments.length) {
    customerSegments = card.customerSegments.map((c) => {
      if (!card.bmcCardRelations.find((relation) => relation && relation.cardId === c.id)) {
        return { cardId: c.id, kind: 'customer_segment' };
      }
    });
  }

  if (card.keyPropositions && card.keyPropositions.length) {
    keyPropositions = card.keyPropositions.map((c) => {
      if (!card.bmcCardRelations.find((relation) => relation && relation.cardId === c.id)) {
        return { cardId: c.id, kind: 'key_proposition' };
      }
    });
  }
  card.bmcCardRelations = card.bmcCardRelations.concat(cardSelects.concat(customerSegments).concat(keyPropositions));
}


export {
  validateCardNumericalFields,
  addBmcCardRelationsAttributes,
  manageBmcCardRelationsAttributes,
  updateBmcCardRelationsAttributes,
  clearCircularStructure,
};
